// Dynamic Gallery Data Structure
// This file manages gallery items that can be loaded from various sources
// Categories are now generated dynamically from Google Drive folders
export const GALLERY_CATEGORIES = [];

// Google Drive Configuration for your specific folder
export const GOOGLE_DRIVE_CONFIG = {
  // Your specific folder ID from the shared link
  folderId: '13PrTu3va-MhSvT6XPPXYgf7NCSqqsUv9',
  
  // Base URLs for Google Drive images
  baseUrl: 'https://drive.google.com/uc?export=view&id=',
  thumbnailUrl: 'https://drive.google.com/thumbnail?id=',
  
  // Supported image formats
  supportedFormats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.tiff'],
  
  // Image quality settings
  thumbnailSize: 'w400', // 400px width for thumbnails
  fullSize: 'w1200',     // 1200px width for full images
  
  // Alternative methods for accessing images
  alternativeUrls: {
    // Method 1: Direct file access (may not work due to permissions)
    direct: 'https://drive.google.com/file/d/{fileId}/view?usp=sharing',
    
    // Method 2: Export as image (more reliable)
    export: 'https://drive.google.com/uc?export=view&id={fileId}',
    
    // Method 3: Thumbnail (fastest loading)
    thumbnail: 'https://drive.google.com/thumbnail?id={fileId}&sz={size}',
    
    // Method 4: Download (for high quality)
    download: 'https://drive.google.com/uc?export=download&id={fileId}'
  }
};

// No sample data - everything comes from Google Drive
export const SAMPLE_GALLERY_ITEMS = [];

// Enhanced Google Drive integration helper
export const getGoogleDriveImageUrl = (fileId, size = 'thumbnail', method = 'thumbnail') => {
  try {
    if (!fileId) return null;
    
    const config = GOOGLE_DRIVE_CONFIG.alternativeUrls;
    
    switch (method) {
      case 'direct':
        return config.direct.replace('{fileId}', fileId);
      case 'export':
        return config.export.replace('{fileId}', fileId);
      case 'thumbnail':
        return config.thumbnail
          .replace('{fileId}', fileId)
          .replace('{size}', size === 'thumbnail' ? GOOGLE_DRIVE_CONFIG.thumbnailSize : GOOGLE_DRIVE_CONFIG.fullSize);
      case 'download':
        return config.download.replace('{fileId}', fileId);
      default:
        return config.thumbnail
          .replace('{fileId}', fileId)
          .replace('{size}', GOOGLE_DRIVE_CONFIG.thumbnailSize);
    }
  } catch (error) {
    console.error('Error generating Google Drive URL:', error);
    return null;
  }
};

// Function to extract file ID from various Google Drive URL formats
export const extractGoogleDriveFileId = (url) => {
  try {
    if (!url) return null;
    
    // Handle different Google Drive URL formats
    const patterns = [
      /\/d\/([a-zA-Z0-9-_]+)/,           // /d/fileId
      /\/file\/d\/([a-zA-Z0-9-_]+)/,     // /file/d/fileId
      /id=([a-zA-Z0-9-_]+)/,             // id=fileId
      /\/open\?id=([a-zA-Z0-9-_]+)/      // /open?id=fileId
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) return match[1];
    }
    
    return null;
  } catch (error) {
    console.error('Error extracting file ID:', error);
    return null;
  }
};

// Function to fetch images from your Google Drive folder
export const fetchGoogleDriveImages = async () => {
  try {
    // Note: This requires Google Drive API setup
    // For now, we'll use a fallback approach
    
    console.log('Fetching images from Google Drive folder:', GOOGLE_DRIVE_CONFIG.folderId);
    
    // Return sample data for now
    // In production, this would make an API call to Google Drive
    return SAMPLE_GALLERY_ITEMS;
    
  } catch (error) {
    console.error('Error fetching from Google Drive:', error);
    return SAMPLE_GALLERY_ITEMS;
  }
};

// Helper function to validate image URL
export const isValidImageUrl = (url) => {
  if (!url) return false;
  
  // Check if it's a Google Drive URL
  if (url.includes('drive.google.com')) return true;
  
  // Check if it's a valid image URL
  const imageExtensions = GOOGLE_DRIVE_CONFIG.supportedFormats;
  return imageExtensions.some(ext => url.toLowerCase().includes(ext));
};

// Gallery item type definition
export const createGalleryItem = (data) => ({
  id: data.id || Date.now(),
  category: data.category || 'projects',
  title: data.title || '',
  description: data.description || '',
  imageUrl: data.imageUrl || '',
  thumbnailUrl: data.thumbnailUrl || '',
  tags: data.tags || [],
  studentName: data.studentName || '',
  course: data.course || '',
  date: data.date || new Date().toISOString().split('T')[0],
  externalUrl: data.externalUrl || '',
  likes: data.likes || 0,
  views: data.views || 0,
  metadata: data.metadata || {},
  // Google Drive specific fields
  driveFileId: data.driveFileId || null,
  driveFileName: data.driveFileName || '',
  driveFileSize: data.driveFileSize || '',
  driveLastModified: data.driveLastModified || ''
});

const galleryData = {
  GOOGLE_DRIVE_CONFIG,
  getGoogleDriveImageUrl,
  extractGoogleDriveFileId,
  fetchGoogleDriveImages,
  isValidImageUrl,
  createGalleryItem
};

export default galleryData;
